import { useLocation } from 'wouter'
import { useCasquette } from '../../contexts/casquette'
import { useActionsPortail } from '../../contexts/navigation'
import RinaContextCard from '../../components/RinaContextCard'
import PageHub from '../../components/PageHub'
import AidePage from './AidePage'
import { ROUTES } from '../../routes'

/** Page « Aide & contact » (S56) : entree a trois portes (/account/aide). */
export default function PageAide() {
  const [, setLocation] = useLocation()
  const { hubMode } = useCasquette()
  const { handleRinaClick } = useActionsPortail()
  return (
    <PageHub retour={{ label: 'Compte', vers: ROUTES.compte.base }}>
      <div className="animate-fade-up">
        <RinaContextCard title="Aide & contact" message="Une question ? Je réponds tout de suite, et l'équipe prend le relais si besoin." />
        <AidePage
          tc="text-ink" ts="text-ink/60" cardBg="bg-card border-card-border" hubMode={hubMode}
          onRina={handleRinaClick}
          onFaq={() => setLocation(ROUTES.compte.aideFaq)}
          onContact={() => setLocation(ROUTES.compte.aideContact)}
          onOuvrirQuestion={(id) => setLocation(`${ROUTES.compte.aideFaq}?q=${encodeURIComponent(id)}`)}
        />
      </div>
    </PageHub>
  )
}
